import { Injectable } from '@angular/core';
import { FnLocalStorageService } from 'foundation';

@Injectable({
  providedIn: 'root'
})
export class RouterServiceService extends FnLocalStorageService {

  constructor() { super();}

  setData(data:any){
    this.setItem('menuItemArray', data);
  }

  getData(data:string){
    return this.getItem<string[]>(data);
  }

  removeData(data:string){
  this.removeItem(data);
  }
}
